import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

import heroBg from "./assets/safetyHero.jpg";
import pinkCar from "./assets/rolopink.png";
import greenCar from "./assets/Evcar.png";
import tracking from "./assets/becomedriver/tracking.jpg";
import verfied from "./assets/becomedriver/verified.jpg";
import payment from "./assets/becomedriver/payment.jpg";
import shareRide from "./assets/becomedriver/shareRide.jpg";
import support from "./assets/becomedriver/support.jpg";
import before from "./assets/before.png";
import during from "./assets/during.png";
import after from "./assets/after.png";
import { useState } from "react";
function Safety() {
    const [showDownloadMenu, setShowDownloadMenu] = useState(false);

  return (
    <div className="safety-page">
      <Navbar />

      {/* HERO */}
      <section
        className="safety-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-overlay"></div>

        <div className="hero-text">
          <h1>“Your Safety Is <br /> Our Top Priority”</h1>
          <p>
           From driver verification to real-time tracking,<br/> Rolo Transit is built to keep every journey safe,<br/> transparent, and worry-free.
          </p>
        </div>
      </section>

      {/* 3 STAGE SAFETY */}
      <section className="safety-stage">
        <h2>Our 3-Stage Safety Approach</h2>

        <div className="stage-grid">
          <div className="stage-card">
            <div className="icon-box">
              <div className="icon-box">
  <img 
    src={before} 
    alt="Before Ride" 
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "8px"
    }} 
  />
</div>
            </div>
            <h4>Before Your Ride</h4>
            <p>Driver checks, vehicle inspections, screening.</p>
          </div>

          <div className="stage-card">
            <div className="icon-box"> <img 
    src={during} 
    alt="During Ride" 
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "8px"
    }} 
  /></div>
            <h4>During Your Ride</h4>
            <p>Live tracking, SOS button, ride sharing.</p>
          </div>

          <div className="stage-card">
            <div className="icon-box">
              <img 
    src={after} 
    alt="After Ride" 
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "8px"
    }} 
  />
            </div>
            <h4>After Your Ride</h4>
            <p>Feedback, support, incident reporting.</p>
          </div>
        </div>
      </section>

      {/* TRAINED DRIVERS */}
      <section className="trained-banner">
        <h3>Trained & Verified Drivers</h3>
        <p>
          Every Rolo Transit driver goes through a strict multi-step verification process including ID checks, license validation and background screening. Our drivers are also trained in customer service, emergency handling and<br/> local navigation
        </p>
      </section>

      {/* RIDE PROTECTED */}
      <section className="ride-protected">
        <h2>Your Ride, Protected</h2>

        <div className="protect-grid">
          <div className="protect-card">
            <div className="icon-box">
                <img src={tracking} alt="Real-time Tracking" style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'8px'}} />
            </div>
            <h4>Real-time Tracking</h4>
            <p>Share your trip and stay in the loop.</p>
          </div>

          <div className="protect-card">
            <div className="icon-box">
                <img src={verfied} alt="In-App SOS Button" style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'8px'}} />
            </div>
            <h4>In-App SOS Button</h4>
            <p>Access help immediately when needed.</p>
          </div>

          <div className="protect-card">
            <div className="icon-box">
                <img src={verfied} alt="Verified Drivers" style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'8px'}} />
            </div>
            <h4>Verified Drivers</h4>
            <p>Only screened drivers, every time.</p>
          </div>

          <div className="protect-card">
            <div className="icon-box">
                   <img src={payment} alt="Ride Details Displayed" style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'8px'}} />
            </div>
            <h4>Ride Details Displayed</h4>
            <p>See vehicle number, driver photo and rating.</p>
          </div>

          <div className="protect-card">
            <div className="icon-box">
                <img src={shareRide} alt="Share Ride Option" style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'8px'}} />
            </div>
            <h4>Share Ride Option</h4>
            <p>Live route sharing for your peace of mind.</p>
          </div>

          <div className="protect-card">
            <div className="icon-box">
                <img src={support} alt="24/7 Support" style={{width:'100%', height:'100%', objectFit:'cover', borderRadius:'8px'}} />
            </div>
            <h4>24/7 Support</h4>
            <p>Help is always just a call or chat away.</p>
          </div>
        </div>
      </section>

      {/* INCLUSIVITY */}
      <section className="inclusivity">
        <h2>Our Commitment to <br/>
        Inclusivity & Sustainability</h2>

        <div className="inclusivity-grid">
          <div className="pink-card">
            <h3>Rolo Pink</h3>
            <p>“Rides by women, for women safe, comfortable and dedicated.”</p>
            <img src={pinkCar} alt="Rolo Pink" />
          </div>

          <div className="green-card">
            <h3>Rolo Green</h3>
            <p>
              “Eco-friendly rides using electric & hybrid vehicles for a
              cleaner planet.”
            </p>
            <img src={greenCar} alt="Rolo Green" />
          </div>
        </div>
      </section>

      {/* REPORT */}
      <section className="report-banner">
        <h3>Report or Reach Us Anytime</h3>
        <p>
          In case of any issue, our dedicated safety team is available 24/7.
          Use the <br/>in-app SOS, contact us or report incidents easily.
        </p>
      </section>
<section className="driver-cta">
        <h3>Ready for a safe ride?<br/>
        Book with Rolo Transit now."</h3>

       <div className="cta-buttons">
  


                          <div style={{ position: "relative", display: "inline-block" }}>
  <button
    className="download"
    onClick={() => setShowDownloadMenu(!showDownloadMenu)}
  >
    <i className="fas fa-download me-2"></i>Download App
  </button>
    {showDownloadMenu && (
<div
  style={{
    position: "absolute",
    top: "110%",
    left: 0,
    minWidth: "220px",
    padding: "10px",
    borderRadius: "18px",
    background: "rgba(20, 20, 20, 0.95)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow:
      "0 10px 30px rgba(0,0,0,0.35), 0 0 20px rgba(252,147,68,0.15)",
    zIndex: 1000,
    overflow: "hidden",
  }}
>
  <a
    href="https://play.google.com/store/apps/details?id=com.rolo.rolocabsautobike"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(61, 220, 132, 0.15)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-android"
      style={{
        color: "#3DDC84",
        fontSize: "22px",
      }}
    />
    Android
  </a>

  <a
    href="https://apps.apple.com/in/app/rolo-cab-auto-bike/id6768391666"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "14px 16px",
      textDecoration: "none",
      color: "#fff",
      borderRadius: "12px",
      transition: "all 0.3s ease",
      fontWeight: "500",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.12)";
      e.currentTarget.style.transform = "translateX(5px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.transform = "translateX(0)";
    }}
  >
    <i
      className="fab fa-apple"
      style={{
        color: "#ffffff",
        fontSize: "22px",
      }}
    />
    iOS
  </a>
</div>
    )}
</div>

  
  

</div>
      </section>
      <Footer />

      <style>{`

.safety-page{
background:#000;
color:white;
font-family:Arial, sans-serif;
}

/* HERO */

.safety-hero{
height:100vh;
background-size:cover;
background-position:center;
display:flex;
align-items:center;
padding:0 10%;
position:relative;
}

.hero-overlay{
position:absolute;
top:0;
left:0;
right:0;
bottom:0;
background:linear-gradient(to right,rgba(0,0,0,0.85),rgba(0,0,0,0.4));
}

.hero-text{
position:relative;
z-index:2;
max-width:600px;
}

.hero-text h1{
font-size:50px;

background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

margin-bottom:15px;
font-weight:700;
}

.hero-text p{
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 121%;
  letter-spacing: 0;
  color: #ddd;
}
/* 3 STAGE */

.safety-stage{
padding:80px 10%;
text-align:center;
}

.safety-stage h2{
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 40px;
  line-height: 121%;
  letter-spacing: 0;

  background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  margin-bottom: 50px;
}

.stage-grid{
  display:grid;
  grid-template-columns:repeat(3, 262px);
  justify-content:center;
  gap:40px;
}

.stage-card{
  width:262px;
  height:262px;
  background:#e6d8cc;
  color:#000;
  padding:30px 25px;
  border-radius:22px;
  position:relative;
  box-sizing:border-box;
}

.stage-card h4{
font-family: 'Inter';
font-weight: 600;
font-size: 20px;
line-height: 121%;
letter-spacing: 0;
color: #D25A00;
text-align:left;

margin-top:20px;
margin-bottom:10px;
}

.stage-card p{
font-family: 'Inter';
font-weight: 500; 
font-size: 14px;
color: #000000;
text-align:left;

}
      
/* ICON BOX */

.icon-box{
width:85px;
height:85px;
background:#ddd;
border-radius:8px;
}

/* TRAINED BANNER */

.trained-banner{
background: #F5F5F5;

color:#000;
text-align:center;
padding:60px 18%;
}

.trained-banner h3{
background:  linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);

-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
font-family: Inter;
font-weight: 800;
font-style: Extra Bold;
font-size: 40px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;

}
.trained-banner p{
font-family: Inter;
font-weight: 500;
font-style: Medium;
font-size: 16px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;
text-align: center;
      }

/* PROTECTED */

.ride-protected{
padding:80px 10%;

}

.ride-protected h2{
text-align:center;
font-family: Inter;
font-weight: 800;
font-style: Extra Bold;
font-size: 40px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;
background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
margin-bottom:25px;
}

.protect-grid{
display:grid;
grid-template-columns:repeat(3,1fr);
gap:30px;
}

.protect-card{
item-align:center;
height:260px;
width:260px;
background:#eee;
color:#000;
padding:30px;
border-radius:14px;
left:244px;

}

.protect-card h4{
color: #D25A00;

margin-top:20px;
margin-bottom:10px;
font-family: Inter;
font-weight: 600;
font-style: Semi Bold;
font-size: 20px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;


}
.protect-card p{
font-family: Inter;
font-weight: 500;
font-style: Medium;
font-size: 16.5px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;
color: #000000;
}

/* INCLUSIVITY */

.inclusivity{
padding:80px 10%;
text-align:center;
}

.inclusivity h2{
background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
margin-bottom:25px;
font-family: Inter;
font-weight: 800;
font-style: Extra Bold;
font-size: 40px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;
text-align: center;


}
.inclusivity h3{
font-family: Inter;
font-weight: 800;
font-style: Extra Bold;
font-size: 36px;
leading-trim: NONE;
line-height: 121%;
letter-spacing: 0%;
text-align: center;
color: #000000;
text-align:left;}

.inclusivity p{
font-family: Inter;
font-weight: 500;
font-style: Medium;
color: #000000;
font-size: 14px;
text-align: left;}

.inclusivity-grid{
display:flex;
justify-content:center;
gap:50px;
flex-wrap:wrap;
}




.pink-card,
.green-card{
width:300px;
padding:30px;
border-radius:14px;
box-shadow:0 8px 20px rgba(0,0,0,0.3);
}

.pink-card{
background:#F6A4C3;
color:#000;
}

.green-card{
background:#b7e58b;
color:#000;
}


.pink-card img,
.green-card img{
width:260px;
margin-top:20px;
}

/* REPORT */

.report-banner{
background: #F5F5F5;
color:#000;
text-align:center;
padding:60px 10%;
}

.report-banner h3{
background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

margin-bottom:10px;
font-family: Inter;
font-weight: 800;
font-style: Extra Bold;
font-size: 40px;
leading-trim: NONE;
line-height: 121%;

}
.report-banner p{
font-family: Inter;
font-weight: 500;
font-style: Medium;
font-size: 18px;
line-height: 121%;
text-align: center;
color: #000000;
      }

      /* DRIVER CTA */

.driver-cta{
  text-align:center;
  padding:60px 10%;
}

.driver-cta h3{
  max-width:555px;
  font-family:'Inter', sans-serif;
  font-weight:800;
  font-size:40px;
  line-height:121%;
  letter-spacing:0;
  text-align:center;

  background:linear-gradient(90deg,#FF7F1F 0%,#C25300 100%);
  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;

  margin:0 auto 10px auto;
}

.cta-buttons{
  margin-top:50px;
  display:flex;
  justify-content:center;
  gap:500px; /* 500px was too large */
}

.join{
  background:white;
  color:black;
  padding:10px 30px;
  border:none;
  border-radius:6px;
}

.download{
  background:#ff8c32;
  color:white;
  padding:10px 30px;
  border:none;
  border-radius:6px;
}

/* RESPONSIVE */

@media(max-width:900px){

.stage-grid{
grid-template-columns:1fr;
}

.protect-grid{
grid-template-columns:1fr;
}

.hero-text h1{
font-size:36px;
}


}

      `}</style>
    </div>
  );
}

export default Safety;